/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { Input } from '@fff-web/fff-ui-shared';
import * as styles from './hero.module.css';
import * as animateStyles from '../animate.module.css';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;
const PHONE_MASK_US_CA = '+1 (___) ___-____';
const PHONE_PLACEHOLDER = '+1 (555) 555-5555';

const phoneNormalizer = (value, previousValue) => {
  const normalizedValue = value.replace(/[^0-9]/g, '');
  return normalizedValue.length > 1 ? normalizedValue.substring(1) : previousValue;
};

const Hero = () => {
  const [phone, setPhone] = useState('');

  const phoneChangeHandler = (event) => {
    const current = event.target.value;
    const normalizedValue = phoneNormalizer(current, phone);
    event.preventDefault();

    setPhone(normalizedValue);
  };

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return 'android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }

    return 'unknown';
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleSendMsg();
  };

  const handleSendMsg = () => {
    if (phone.length === 0) {
      alert('Please enter a valid phone number');
    } else {
      const generalErrorMsg = 'We are unable to send SMS to your number. Please try again later';
      fetch(`${process.env.REACT_APP_MESSAGE_API_URL}/api/1/get-the-app`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          platform: getMobileOperatingSystem(),
          to_number: encodeURI(phone),
        }),
      })
        .then((response) => {
          if (response.ok) {
            alert('Thank you! You will receive the download link via SMS shortly!');
          } else {
            datadogLogs.logger.error('Error sending SMS: ', response);
            alert(generalErrorMsg);
          }
        })
        .catch((e) => {
          datadogLogs.logger.error('Error sending SMS: ', e);
          alert(generalErrorMsg);
        });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Download the Free FabFitFun App Today</h1>
        <div className={styles.sms}>
          <label className={styles['smsLabel']}>Text download link to your phone:</label>
          <form onSubmit={handleSubmit} className={styles['smsForm']}>
            <Input
              className={styles['smsInput']}
              datatestid="phone-number-address-fld"
              name="phone"
              type="phone"
              onChange={phoneChangeHandler}
              characterLimit={20}
              inputMask={PHONE_MASK_US_CA}
              placeholder={PHONE_PLACEHOLDER}
            />
            <button
              type="button"
              id="submit-number-btn"
              className={styles['smsButton']}
              onClick={handleSendMsg}
            >
              SEND
            </button>
          </form>
        </div>
        <div className={styles['appDownloads']}>
          <a href={process.env.REACT_APP_MOBILE_APP_IOS_URL} className={styles['appCta']}>
            <img
              src={`${assertBaseUrl}/images/cta_apple_1574120300.7234_1574120301.1535.png`}
              alt=""
              className={animateStyles.hoverbtn}
            />
          </a>
          <a href={process.env.REACT_APP_MOBILE_APP_ANDROID_URL} className={styles['appCta']}>
            <img
              src={`${assertBaseUrl}/images/cta_android_1574120299.0486_1574120299.4814.png`}
              alt=""
              className={animateStyles.hoverbtn}
            />
          </a>
        </div>
      </div>
      <div className={styles['heroImg']}>
        <img
          src={`${assertBaseUrl}/images/fff-flatlay2.jpeg`}
          alt=""
          className={`${animateStyles.animate} ${animateStyles.fadeinright}`}
        />
      </div>
    </div>
  );
};

export default Hero;
